import { useState } from 'react';
import Image from './oc-image.jsx';
import Modal from '../Modal';
import { jsx, css } from '@emotion/react';

const cardStyles = css`
  display: block;
  color: black;
  margin-bottom: 35px;

  .two-up & {
    flex-basis: 50%;
  }

  .three-up & {
    flex-basis: 33.3333%;
  }

  .four-up & {
    @media(min-width: 768px) {
      flex-basis: 33.3333%;
    }

    @media(min-width: 1200px) {
      flex-basis: 25%;
    }
  }

  &.size-1-3 {
    @media (min-width: $screen-sm) {
      width: calc(33% - 20px);
    }
  }

  h5, .h5 {
    margin: 0 0 10px;
    font-weight: 700;
    text-transform: capitalize;
  }

  .media {
    margin: 0 0 10px;

    img {
      width: 100%;
      max-width: 100%;
    }
  }

  .text {
    p {
      margin: 0 0 15px;
    }
  }
`

const withModalStyles = css`
  .media {
    position: relative;
    overflow: hidden;
    cursor: pointer;
  }

  .media::before {
    content: '\f0b2';
    font-family: "fontawesome";
    color: white;
    font-size: 25px;
    text-shadow: 0 0 3px rgba(0, 0, 0, 0.75);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    background: transparent;
    width: 64px;
    height: 64px;
    align-items: center;
    justify-content: center;
    display: flex;
  }

  .media:hover:before {
    color: #d40f7d;
    background: white;
    text-shadow: none;
    text-decoration: none;
  }

  .media::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: transparent;
  }

  .media:hover:after {
    background: rgba(212,15,125,0.5);
  }
`

const modalStyles = css`
  margin-top: 63px;
  width: 100%;
`

const Card = ({ img, alt, children, addModal }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const toggleModalOpen = () => setModalOpen(!modalOpen)
  return (
    <div className="oc-card" css={[cardStyles, addModal ? withModalStyles : null]}>
      {addModal ?
        <a onClick={toggleModalOpen} tabIndex="0" className="media" data-track="learn-more" data-track-destination={alt}>
          <Image src={img} alt={alt} width="250" className="img-responsive" />
        </a>
      :
        <div className="media">
          <Image src={img} alt={alt} width="250" className="img-responsive" />
        </div>
      }
      <div className="text">
        {children}
      </div>

      <Modal open={modalOpen} onClose={toggleModalOpen}>
        <Image src={img} alt={alt} css={modalStyles} />
        {children}
      </Modal>
    </div>
  )
};

export default Card;
